import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';

import { ReactComponent as NoActionRequiredIcon } from '../../../resources/icons/no-action-required.svg';
import { ReactComponent as ActionRequiredIcon } from '../../../resources/icons/action-required.svg';
import { ReactComponent as NotVerifiedIcon } from '../../../resources/icons/not-verified.svg';
import { ReactComponent as NotificationsIcon } from '../../../resources/icons/notifications.svg';
import { ReactComponent as NoNotificationsIcon } from '../../../resources/icons/no-notifications.svg';
import { ReactComponent as DirectMessagesIcon } from '../../../resources/icons/direct-message.svg';

import './shortcuts.scss';

const Shortcuts = ({ shortcuts, toggleNotifications, areNewNotifications, newNotificationsSize }) => {
  const navigate = useNavigate();

  if (!shortcuts) {
    return null;
  }

  return (
    <section className="shortcuts">
      <button className="shortcuts__shortcut" onClick={() => navigate('/shop/wallet')}>
        <p className="shortcuts__shortcut__name">ATP-Wallet Balance</p>
        <div className="shortcuts__shortcut__content">
          <p>USD {shortcuts.eWallet}</p>
        </div>
      </button>

      <button className="shortcuts__shortcut" onClick={() => navigate('/shop/deal-room')}>
        <p className="shortcuts__shortcut__name">Deal Room</p>
        <div className="shortcuts__shortcut__content">
          <p>{shortcuts.dealRoom}</p>
          {shortcuts.dealRoom === 'No action required' ? <NoActionRequiredIcon /> : <ActionRequiredIcon />}
        </div>
      </button>

      <button className="shortcuts__shortcut" onClick={() => navigate('/shop/product-listings')}>
        <p className="shortcuts__shortcut__name">Listing Management</p>
        <div className="shortcuts__shortcut__content">
          <p>{shortcuts.listingManagement}</p>
          {shortcuts.listingManagement === 'No action required' ? <NoActionRequiredIcon /> : <ActionRequiredIcon />}
        </div>
      </button>

      <button className="shortcuts__shortcut" onClick={() => navigate('/market/direct-messages')}>
        <p className="shortcuts__shortcut__name">Direct Messages</p>
        <div className="shortcuts__shortcut__content">
          <p>{shortcuts.directMessages}</p>
          <DirectMessagesIcon />
        </div>
      </button>

      {shortcuts.verifyYourAccount === 'Not Verified' && (
        <button className="shortcuts__shortcut" onClick={() => navigate('/verification')}>
          <p className="shortcuts__shortcut__name shortcuts__shortcut__name--verification">Verify Your Account</p>
          <div className="shortcuts__shortcut__content shortcuts__shortcut__content--verification">
            <NotVerifiedIcon />
          </div>
        </button>
      )}

      <button className="shortcuts__shortcut" onClick={toggleNotifications}>
        <p className="shortcuts__shortcut__name">Notifications</p>
        <div className="shortcuts__shortcut__content">
          <p>{newNotificationsSize}</p>
          {areNewNotifications ? <NotificationsIcon /> : <NoNotificationsIcon />}
        </div>
      </button>
    </section>
  );
};

Shortcuts.propTypes = {
  toggleNotifications: PropTypes.func.isRequired,
};

export default Shortcuts;
